import React, {useContext} from "react";
import {AccordionContext} from "./AccordionContext";
import {PanelContext} from "./PanelContext";
import {PanelToggleButton} from "./PanelToggleButton";

type PanelToggleProps = {
  children?: React.ReactNode;
  className?: string;
};

export function PanelToggle({
  children,
  className,
}: PanelToggleProps): JSX.Element {
  const {disabled, expanded, toggle, withChevron, withPlusMinus} =
    useContext(PanelContext);
  const {crossBrand, unstyled, minWidth, sticky, snapToTopOnClose} =
    useContext(AccordionContext);
  return (
    <PanelToggleButton
      aria-expanded={expanded ? "true" : "false"}
      className={className}
      crossBrand={crossBrand}
      disabled={disabled}
      expanded={expanded}
      minWidth={minWidth}
      onClick={toggle}
      snapToTopOnClose={snapToTopOnClose}
      sticky={sticky}
      unstyled={unstyled}
      withChevron={withChevron}
      withPlusMinus={withPlusMinus}
    >
      {children}
    </PanelToggleButton>
  );
}
